import { TemplateRef } from '@angular/core';
import { IScrollData } from '@core/interfaces/common.interfaces';

// Enums ###################################################################
export enum ModalAlignContentItemsEnum {
	AS_COLUMNS = 'column',
	AS_ROWS = 'row'
}

export enum ModalBaseEventTypeEnum {
	ASIDE_HIDE = 'aside hide',
	ASIDE_SHOW = 'aside show',
	CLOSE = 'close',
	CONTENT_ALIGNMENT_CHANGE = 'content alignment change',
	CONTENT_SCROLL = 'content scroll',
	FOOTER_HIDE = 'footer hide',
	FOOTER_SHOW = 'footer show',
	HEADER_HIDE = 'header hide',
	HEADER_SHOW = 'header show',
	OVERLAY_HIDE = 'overlay hide',
	OVERLAY_SHOW = 'overlay show',
	PRE_FOOTER_HIDE = 'pre-footer hide',
	PRE_FOOTER_SHOW = 'pre-footer show',
	SUBHEADER_HIDE = 'subheader hide',
	SUBHEADER_SHOW = 'subheader show',
}

export enum ModalIdentifierEnum {
	ARCHIVING_EXPORT = 'archivingExport',
	ARCHIVING_PROCEDURAL_DOCUMENTATION_IMPORT = 'archivingProceduralDocumentation',
	ARCHIVING_PROCEDURAL_DOCUMENTATION_EXPORT = 'archivingProceduralDocumentationExport',
	ARCHIVING_OPEN_ARCHIVE_BULK_EXPORT = 'archivingOpenArchiveBulkExport',
	ARCHIVING_OPEN_ARCHIVE_BULK_KEYWORD = 'archivingOpenArchiveBulkKeyword',
	ARCHIVING_OPEN_ARCHIVE_IMPORT = 'archivingOpenArchiveImport',
	ARCHIVING_TSS_LOG_EXPORT = 'archivingTssLogExport',
	CODE_EDITOR = 'codeEditor',
	CONFIGURATION_ACCOUNT = 'configurationAccount',
	CONFIGURATION_BUSINESS_PREMISES = 'configurationBusinessPremises',
	ENCRYPTION_KEY = 'encryptionKey',
	ERS_LIFECYCLE = 'ersLifecycle',
	INVALID_TENANT = 'invalidTenant',
	KEYWORDS_MANAGE = 'keywordsManage',
	PROFILE = 'profile',
	SELECT_VERSION = 'selectVersion',
	SHOW_RESULT = 'showResult',
	STRUCTURE_IMPORT = 'structureImport',
	STRUCTURE_EXPORT = 'structureExport',
	TASK_CENTER = 'taskCenter',
	TAXATION_REPORTING_CONFIRMATION = 'taxationReportingConfirmation',
	TSS_LIFECYCLE = 'tssLifecycle',
	TSS_REQUEST = 'requestTss',
	TSS_LOG_BULK_ACKNOWLEDGE = 'tssLogBulkAcknowledge',
	TSS_LOG_BULK_DOWNLOAD = 'tssLogBulkDownload'
}

/**
 * Choose possible header content - plain string or common context container.
 */
export enum ModalHeaderContentTypeEnum {
	VALUE = 'value', 			// classic string value for title as input from child
	PROJECTED = 'content', 	// any projected content from child as container
}

export enum ModalSizeEnum {
	SM = 'sm',
	LG = 'lg',
	XL = 'xl'
}


// Interfaces #############################################################
export interface IModalBaseEvent extends IModalBaseEventProperties {
	event: ModalBaseEventTypeEnum;
}

export interface IModalBaseEventProperties {
	contentAlignment?: ModalAlignContentItemsEnum;
	contentBodyScrollData?: IScrollData;
	overlayTemplateRef?: TemplateRef<HTMLTemplateElement>;
}


export interface IModalOptions {
	asFullpage?: IModalOptionsFullPage;
	asOverlay?: IModalOptionsOverlay;
}

interface IModalOptionsBase {
	animation?: boolean;
	ariaLabelledBy?: string;
	ariaDescribedBy?: string;
	keyboard?: boolean;
	windowClass?: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IModalOptionsFullPage extends IModalOptionsBase {}

export interface IModalOptionsOverlay extends IModalOptionsBase {
	backdrop?: boolean | 'static';
	backdropClass?: string;
	centered?: boolean;
	size?: ModalSizeEnum | string;
}
